'use client';

import { useBreakpoints } from '@nettbureau/featured-core';
import {
  ChildrenProps,
  Container,
  Item,
  VStack,
  useCss,
} from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTheme, getTokenFromVibrant } from '../theme';

export function MainContainer({ children }: ChildrenProps) {
  const { isMobile } = useBreakpoints();

  return (
    <Container padding={0} css={{ maxWidth: 1320 }}>
      <Item grow>{children}</Item>
    </Container>
  );
}

interface FeaturedContainerProps extends ChildrenProps {
  gutter?: boolean;
}

export function FeaturedContainer({
  children,
  gutter = true,
}: FeaturedContainerProps) {
  const { isMobile } = useBreakpoints();

  return (
    <MainContainer>
      <VStack
        padding={{ x: 5, y: gutter ? (isMobile ? 8 : 10) : 0 }}
        gap={isMobile ? 8 : 10}
        align="stretch"
      >
        {children}
      </VStack>
    </MainContainer>
  );
}

export function ContainerWithTheme({ children }: ChildrenProps) {
  const { globalThemeVariant, theme } = useContext(ConfigContext);

  const styles = useCss((input) => {
    return {
      background: getTokenFromVibrant(
        globalThemeVariant === 'default'
          ? getTheme(theme).default.background.backgroundColor
          : globalThemeVariant === 'secondary'
            ? getTheme(theme).secondary.background.backgroundColor
            : globalThemeVariant === 'districtPicker'
              ? getTheme(theme).districtPicker.background.backgroundColor
              : globalThemeVariant === 'cityListPage'
                ? getTheme(theme).cityListPage.background.backgroundColor
                : getTheme(theme).vendorListPage.background.backgroundColor,
        input.theme,
      ),
    };
  });

  return <VStack css={styles}>{children}</VStack>;
}
